export default "__VITE_PUBLIC_ASSET__5308318f__"